import * as React from "react";

const SentryInitializer = React.lazy(() => import("./sentry-init.web"));

export default function SentryLoader() {
  const [shouldLoad, setShouldLoad] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => setShouldLoad(true), 100);
    return () => clearTimeout(timer);
  }, []);

  if (!shouldLoad) return null;

  return (
    <React.Suspense fallback={null}>
      <SentryInitializer />
    </React.Suspense>
  );
}
